{
  "RenderCalloutForm": {
    "searchLocation": "Szukaj lokalizacji",
    "selectDate": "Wybierz datę",
    "select": "Wybierz",
    "enterAmount": "Wprowadź kwotę",
    "fileUploaderLabel": "Obsługiwane formaty: .jpg, .png, .heic, .gif, .webp, .mp4, .mov, .pdf - (maks. 10mb na plik)",
    "removeFile": "Usuń plik",
    "from": "Od",
    "to": "Do",
    "selectDates": "Wybierz daty",
    "optional": "opcjonalne",
    "addLabel": "Dodaj etykietę",
    "addDescription": "Dodaj opis",
    "validationError": "Błąd walidacji: Sprawdź, czy wszystkie pola są poprawne",
    "submit": "Wyślij",
    "emptyForm": "Wybierz pola z lewej, aby kandydaci mogli je wypełnić"
  },
  "CalloutCreateModal": {
    "createCallout": "Utwórz ogłoszenie",
    "editCallout": "Edytuj ogłoszenie",
    "duplicateCallout": "Duplikuj ogłoszenie",
    "callout": "Ogłoszenie",
    "couldNotCreateCallout": "Nie udało się utworzyć ogłoszenia",
    "couldNotUpdateCallout": "Nie udało się zaktualizować ogłoszenia",
    "details": "Szczegóły",
    "title": "Tytuł",
    "titlePlaceholder": "Ogłoszenie o castingu na sesję świąteczną...",
    "defaultResourceType": "Domyślny typ zasobu",
    "selectResourceTypeInfo": "Wybierz typ zasobu, który zostanie ustawiony przy dodawaniu kandydata",
    "resourceType": "Typ zasobu",
    "resourceTypePlaceholder": "Wybierz typ zasobu",
    "resourceTypeRequired": "Wybierz typ zasobu",
    "template": "Szablon",
    "templateInfo": "To da ci sugerowany zestaw pól do rozpoczęcia edycji",
    "cancel": "Anuluj",
    "saveChanges": "Zapisz zmiany"
  },
  "CalloutDetail": {
    "build": "Buduj",
    "preview": "Podgląd",
    "publish": "Opublikuj",
    "applicants": "Kandydaci",
    "backToEdit": "Wróć do edycji",
    "unpublishAndEdit": "Cofnij publikację i edytuj",
    "unpublishAndEditTip": "Cofnij publikację ogłoszenia, aby edytować"
  },
  "CalloutActions": {
    "share": "Udostępnij",
    "duplicate": "Duplikuj",
    "edit": "Edytuj",
    "editCallout": "Edytuj ogłoszenie",
    "transfer": "Przenieś do przestrzeni roboczej",
    "archive": "Archiwizuj",
    "unarchive": "Przywróć z archiwum",
    "moreActions": "Więcej akcji",
    "archiveSuccess": "Ogłoszenie zarchiwizowane",
    "unarchiveSuccess": "Ogłoszenie przywrócone z archiwum",
    "archiveError": "Nie udało się zarchiwizować ogłoszenia: {{error}}",
    "unarchiveError": "Nie udało się przywrócić ogłoszenia z archiwum: {{error}}"
  },
  "CalloutDialog": {
    "createCallout": "Utwórz ogłoszenie",
    "editCallout": "Edytuj ogłoszenie",
    "duplicateCallout": "Duplikuj ogłoszenie",
    "duplicate": "Duplikuj",
    "details": "Szczegóły",
    "template": "Szablon",
    "templateInfo": "To da ci sugerowany zestaw pól do rozpoczęcia edycji",
    "slug": "Slug URL",
    "slugInvalid": "Używaj tylko małych liter, cyfr i myślników",
    "slugRequired": "Slug jest wymagany",
    "slugSyncFromTitle": "Synchronizuj z tytułem",
    "slugUuidDisallowed": "Slug nie może wyglądać jak UUID",
    "slugDuplicate": "Ten slug jest już używany",
    "next": "Dalej",
    "back": "Wstecz",
    "backWithArrow": "← Wstecz",
    "cancel": "Anuluj",
    "create": "Utwórz ogłoszenie",
    "saveChanges": "Zapisz zmiany",
    "selectTemplate": "Wybierz szablon",
    "selectTemplateHint": "Wybierz szablon",
    "templateSelectedCount": "Wybrano: {{count}}",
    "unselectAll": "Odznacz wszystko",
    "unselectAllTemplates": "Odznacz wszystkie szablony",
    "templateFieldCount": "{{count}} pól",
    "couldNotCreateCallout": "Nie udało się utworzyć ogłoszenia",
    "couldNotUpdateCallout": "Nie udało się zaktualizować ogłoszenia"
  },
  "templates": {
    "basicCallout": {
      "name": "💁🏽‍♂️️ Podstawowe ogłoszenie",
      "description": "Podstawowy formularz do zbierania informacji kontaktowych",
      "mappings": {
        "full_name": {
          "label": "Imię i nazwisko",
          "description": ""
        },
        "emails": {
          "label": "Email",
          "description": ""
        },
        "phone_number": {
          "label": "Numer telefonu",
          "description": ""
        },
        "websites": {
          "label": "Link do strony (URL)",
          "description": ""
        },
        "locations": {
          "label": "Adres",
          "description": "Wyszukaj i wybierz adres poniżej"
        }
      }
    },
    "portfolioCallout": {
      "name": "📸 Ogłoszenie portfolio",
      "description": "Formularz do zbierania informacji kontaktowych i próbek prac",
      "mappings": {
        "full_name": {
          "label": "Imię i nazwisko",
          "description": ""
        },
        "emails": {
          "label": "Email",
          "description": ""
        },
        "phone_number": {
          "label": "Numer telefonu",
          "description": ""
        },
        "websites": {
          "label": "Strona internetowa",
          "description": ""
        },
        "locations": {
          "label": "Lokalizacja",
          "description": "Gdzie mieszkasz?"
        },
        "files": {
          "label": "Prześlij próbki",
          "description": "Prześlij co najmniej trzy próbki prac"
        }
      }
    },
    "modelCallout": {
      "name": "⭐️ Ogłoszenie dla modeli",
      "description": "Formularz do zbierania informacji o modelach do castingu",
      "mappings": {
        "full_name": {
          "label": "Imię i nazwisko",
          "description": ""
        },
        "emails": {
          "label": "Email",
          "description": "Podaj swój lub agenta adres email"
        },
        "phone_number": {
          "label": "Numer telefonu",
          "description": "Podaj swój lub agenta numer telefonu"
        },
        "websites": {
          "label": "Link do strony (URL)",
          "description": "Link do Twojego portfolio"
        },
        "social_instagram": {
          "label": "Instagram",
          "description": "Jeśli posiadasz konto na Instagramie, podaj swój nick"
        },
        "locations": {
          "label": "Lokalizacja",
          "description": "Gdzie jesteś zlokalizowany?"
        },
        "files": {
          "label": "Zdjęcia portfolio",
          "description": "Prześlij co najmniej 3 zdjęcia z poprzednich projektów"
        }
      }
    }
  },
  "fieldMappings": {
    "social_instagram": "Instagram",
    "social_twitter": "Twitter",
    "social_behance": "Behance",
    "social_youtube": "Youtube",
    "social_vimeo": "Vimeo",
    "profile_picture": "Zdjęcie profilowe",
    "full_name": "Imię i nazwisko",
    "files": "Przesyłanie multimediów",
    "role": "Rola",
    "websites": "Strona internetowa",
    "emails": "Email",
    "phone_numbers": "Numer telefonu",
    "locations": "Lokalizacje",
    "rates": "Stawka",
    "tags": "Tagi",
    "groups": "Grupy"
  },
  "CalloutForm": {
    "termsSection": "Regulamin",
    "termsTitle": "Regulamin",
    "termsTitlePlaceholder": "Tytuł regulaminu",
    "termsContentPlaceholder": "Treść regulaminu",
    "termsCheckboxLabelPlaceholder": "Tekst potwierdzenia",
    "termsPrivacyNotice": "Informacja o ochronie danych: Przesyłając zgłoszenie, wyrażasz zgodę na zbieranie i przetwarzanie swoich danych osobowych w celach castingu i rezerwacji. Twoje dane będą wykorzystywane do oceny Twojej przydatności do naszych kampanii i mogą być udostępniane naszym partnerom produkcyjnym. Udział jest dobrowolny, możesz wycofać swoje zgłoszenie w dowolnym momencie, kontaktując się z nami. Zobowiązujemy się do ochrony Twojej prywatności i przetwarzania danych zgodnie z obowiązującymi przepisami o ochronie danych.",
    "termsRequired": "Musisz zaakceptować regulamin",
    "termsCheckboxLabel": "Akceptuję przedstawione powyżej warunki",
    "submitError": "Wystąpił błąd podczas wysyłania formularza. Spróbuj ponownie.",
    "submitting": "Wysyłanie...",
    "submitApplication": "Wyślij zgłoszenie",
    "successTitle": "Zgłoszenie wysłane",
    "successMessage": "Dziękujemy za zgłoszenie. Skontaktujemy się z Tobą, jeśli uznamy, że pasujesz do naszych projektów.",
    "submitAnother": "Wyślij kolejne zgłoszenie"
  },
  "ApplicantSubmittedModal": {
    "title": "Zgłoszenie wysłane",
    "thanksMessage": "Dziękujemy za przesłanie. Wkrótce się skontaktujemy.",
    "successMessage": "Dziękujemy za zgłoszenie. Skontaktujemy się z Tobą, jeśli uznamy, że pasujesz do naszych projektów.",
    "submitAnother": "Wyślij kolejne zgłoszenie"
  },
  "CalloutFormControls": {
    "invalidEmail": "Nieprawidłowy adres email",
    "locationPlaceholder": "Wybierz lokalizację",
    "locationSearchPrompt": "Szukaj lokalizacji",
    "locationEmpty": "Nie znaleziono lokalizacji",
    "locationUseTypedText": "Użyj „<query></query>”"
  },
  "CalloutBuilderField": {
    "dragToReorder": "Przeciągnij, aby zmienić kolejność: {{name}}",
    "labelPlaceholder": "Dodaj etykietę",
    "descriptionPlaceholder": "Dodaj opis",
    "required": "Wymagane",
    "remove": "Usuń pole: {{name}}"
  },
  "TransferCalloutDialog": {
    "title": "Przenieś do przestrzeni roboczej",
    "description_one": "Przenieś {{name}} do innej przestrzeni roboczej.",
    "description_other": "Przenieś {{count}} ogłoszeń do innej przestrzeni roboczej.",
    "fieldWorkspace": "Docelowa przestrzeń robocza",
    "success_one": "Ogłoszenie przeniesione",
    "success_other": "Przeniesiono {{count}} ogłoszeń"
  }
}
